<div class="content-wrapper p-0">
	<div class="content-body">
		<app-content-header [contentHeader]="contentHeader"></app-content-header>
		<section class="app-ecommerce-details">
			<div class="card">
				<div class="bs-stepper horizontal-wizard-example">
					<div class="bs-stepper-header">
						<b>Proforma for Project Completion Report (PCR)</b>
					</div>
					<div class="bs-stepper-content">
						<div class="card-body">
							<div class="users-list-filter">
								<form [formGroup]="completionForm" autocomplete="off">
									<fieldset class="border" style="padding: 0.7rem;">
										<legend class="w-auto">
											<h5 style="margin-top: 7px;">Title of the Project:</h5>
										</legend>
										<div class="row">
											<div class="form-group col-md-4">
												<span class="font-bold">Principal Investigator(s) : </span>
												<span  class="text-wrap text-justify">{{principleInvestigator}}</span>
											</div>
											<!-- <div class="form-group col-md-4">
												<span class="font-bold">Co-Investigator(s) : </span>
												<span>{{coPrincipleInvestigator}}</span>
											</div> -->
											<div class="form-group col-md-4">
												<span class="font-bold">Implementing Institution(s) : </span>
												<span class="text-wrap text-justify">{{category_imp_institution}}</span>
											</div>
											<div class="form-group col-md-4">
												<span class="font-bold">Collaborating Institution(s) : </span>
												<div class="text-wrap text-justify">{{collaboratingOrg}}</div>
											</div>
										</div>
										<div class="row">
											<div class="form-group col-md-4">
												<span class="font-bold">Date of Commencement of Project : </span>
												<span>{{createdDate}}</span>
											</div>
											<div class="form-group col-md-4">
												<span class="font-bold">Actual Date of Completion : </span>
												<span>{{endDate}}</span>
											</div>
										</div>
										<div class="row">
											<div class="col-md-12">
												<span class="font-bold">Objectives of the Project : </span>
												<div class="text-wrap text-justify">{{objectives}}</div>
											</div>
										</div>
										<div class="row pt-2">
											<div class="form-group col-md-4">
												<label for="account-birth-date">Approved Date of Completion <span class="required-asterisk">*</span></label>
												<div class="input-group">
													<input class="form-control" placeholder="dd-mm-yyyy"
														name="dateofCompletions" formControlName="dateofCompletions"
														ngbDatepicker #MinMaxDP="ngbDatepicker"
														[minDate]="{year: minDate.year, month: minDate.month, day:minDate.day}"
														[maxDate]="{year: maxDate.year, month: maxDate.month, day:maxDate.day}"
														[ngClass]="{ 'is-invalid': submitted && !formDetails.dateofCompletions.valid }"
														[readonly]="true" />
													<div class="input-group-append">
														<button class="btn btn-outline-secondary feather icon-calendar"
															(click)="MinMaxDP.toggle();" type="button"
															rippleEffect></button>
													</div>
												</div>
												<span *ngIf="submitted && formDetails.dateofCompletions.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="formDetails.dateofCompletions.errors.required">This
														field is required!</small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="patentsTaken">Patents Taken <span
														class="required-asterisk">*</span></label>
												<input formControlName="patentsTaken" type="text" name="patentsTaken"
													id="patentsTaken" class="form-control" placeholder="Patents taken"
													[ngClass]="{ 'is-invalid': submitted && !formDetails.patentsTaken.valid }" />
												<span *ngIf="submitted && formDetails.patentsTaken.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="formDetails.patentsTaken.errors.required">This
														field is required!</small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="outputOfProject">Output of the
													Project <span class="required-asterisk">*</span></label>
												<textarea formControlName="outputOfProject" type="text"
													name="outputOfProject" id="outputOfProject" rows="1"
													class="form-control" placeholder="Output of the Project"
													[ngClass]="{ 'is-invalid': submitted && !formDetails.outputOfProject.valid }"></textarea>
												<span *ngIf="submitted && formDetails.outputOfProject.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="formDetails.outputOfProject.errors.required">This
														field is required!</small>
												</span>
											</div>
										</div>
									</fieldset>
									<fieldset class="border" style="padding: 0.5rem;">
										<legend class="w-auto">
											<h5 style="margin-top: 7px;">S&T Benefits Accrued:</h5>
										</legend>
										<div class="form-group">
											<form [formGroup]="researchPublicationForm" *ngIf="researchPublicationForm">
												<table class="table table-striped table-bordered">
													<thead>
														<tr>
															<th>Action</th>
															<th>Authors</th>
															<th>Title of paper*</th>
															<th>Name of the Journal</th>
															<th>Volume</th>
															<th>Pages</th>
															<th>Year</th>
														</tr>
													</thead>
													<tbody formArrayName="publicationArray">
														<tr *ngFor="let item of researchPublicationForm.controls.publicationArray.controls; let $index=index"
															[formGroupName]="$index">
															<td (click)="deletePublicationFormRow($index)">
																<i class="fa fa-trash fa-2x"></i>
															</td>
															<td>
																<input class="form-control" type="text"
																	formControlName="authors"
																	[ngClass]="{ 'is-invalid': researchPublicationForm.controls['publicationArray'].controls[$index].controls['authors'].touched && researchPublicationForm.controls['publicationArray'].controls[$index].controls['authors'].invalid}" />
																<span
																	*ngIf="researchPublicationForm.controls['publicationArray'].controls[$index].controls['authors'].invalid"
																	class="invalid-form">
																	<small class="form-text text-danger"
																		*ngIf="researchPublicationForm.controls['publicationArray'].controls[$index].controls['authors'].touched && researchPublicationForm.controls['publicationArray'].controls[$index].controls['authors'].hasError('required')">
																		Required!
																	</small>
																</span>
															</td>
															<td>
																<input class="form-control" type="text"
																	formControlName="titlepapers"
																	[ngClass]="{ 'is-invalid': researchPublicationForm.controls['publicationArray'].controls[$index].controls['titlepapers'].touched && researchPublicationForm.controls['publicationArray'].controls[$index].controls['titlepapers'].invalid}" />
																<span
																	*ngIf="researchPublicationForm.controls['publicationArray'].controls[$index].controls['titlepapers'].invalid"
																	class="invalid-form">
																	<small class="form-text text-danger"
																		*ngIf="researchPublicationForm.controls['publicationArray'].controls[$index].controls['titlepapers'].touched && researchPublicationForm.controls['publicationArray'].controls[$index].controls['titlepapers'].hasError('required')">
																		Required!
																	</small>
																</span>
															</td>
															<td>
																<input class="form-control" type="text"
																	formControlName="nameOfJournal"
																	[ngClass]="{ 'is-invalid': researchPublicationForm.controls['publicationArray'].controls[$index].controls['nameOfJournal'].touched && researchPublicationForm.controls['publicationArray'].controls[$index].controls['nameOfJournal'].invalid}" />
																<span
																	*ngIf="researchPublicationForm.controls['publicationArray'].controls[$index].controls['nameOfJournal'].invalid"
																	class="invalid-form">
																	<small class="form-text text-danger"
																		*ngIf="researchPublicationForm.controls['publicationArray'].controls[$index].controls['nameOfJournal'].touched && researchPublicationForm.controls['publicationArray'].controls[$index].controls['nameOfJournal'].hasError('required')">
																		Required!
																	</small>
																</span>
															</td>
															<td>
																<input class="form-control" type="text"
																	formControlName="volume"
																	[mask]="'^([1-9]\\d*|0)$'" maxlength="10"
																	[ngClass]="{ 'is-invalid': researchPublicationForm.controls['publicationArray'].controls[$index].controls['volume'].touched && researchPublicationForm.controls['publicationArray'].controls[$index].controls['volume'].invalid}" />
																<span
																	*ngIf="researchPublicationForm.controls['publicationArray'].controls[$index].controls['volume'].invalid"
																	class="invalid-form">
																	<small class="form-text text-danger"
																		*ngIf="researchPublicationForm.controls['publicationArray'].controls[$index].controls['volume'].touched && researchPublicationForm.controls['publicationArray'].controls[$index].controls['volume'].hasError('required')">
																		Required!
																	</small>
																</span>
															</td>
															<td>
																<input class="form-control" type="text"
																	formControlName="pages" [mask]="'^([1-9]\\d*|0)$'"
																	maxlength="10"
																	[ngClass]="{ 'is-invalid': researchPublicationForm.controls['publicationArray'].controls[$index].controls['pages'].touched && researchPublicationForm.controls['publicationArray'].controls[$index].controls['pages'].invalid}" />
																<span
																	*ngIf="researchPublicationForm.controls['publicationArray'].controls[$index].controls['pages'].invalid"
																	class="invalid-form">
																	<small class="form-text text-danger"
																		*ngIf="researchPublicationForm.controls['publicationArray'].controls[$index].controls['pages'].touched && researchPublicationForm.controls['publicationArray'].controls[$index].controls['pages'].hasError('required')">
																		Required!
																	</small>
																</span>
															</td>
															<td>
																<input class="form-control" type="text"
																	formControlName="year"
																	[mask]="'^([1-9]\\d*|0)$'"
																	maxlength="4"
																	[ngClass]="{ 'is-invalid': researchPublicationForm.controls['publicationArray'].controls[$index].controls['year'].touched && researchPublicationForm.controls['publicationArray'].controls[$index].controls['year'].invalid}" />
																<span
																	*ngIf="researchPublicationForm.controls['publicationArray'].controls[$index].controls['year'].invalid"
																	class="invalid-form">
																	<small class="form-text text-danger"
																		*ngIf="researchPublicationForm.controls['publicationArray'].controls[$index].controls['year'].touched && researchPublicationForm.controls['publicationArray'].controls[$index].controls['year'].hasError('required')">
																		Required!
																	</small>
																</span>
															</td>
														</tr>
														<tr>
															<td (click)="addRow()">
																<i class="fa fa-plus fa-2x"></i>
															</td>
														</tr>
													</tbody>
												</table>
											</form>
										</div>
									</fieldset>
									<fieldset class="border" style="padding: 0.7rem;">
										<legend class="w-auto">
											<h5 style="margin-top: 7px;">Document Upload</h5>
										</legend>
										<label>(Upload PDF of size upto 25MB)</label>
										<div class="row">
											<div class="form-group col-md-12">
												<form [formGroup]="documentForm" *ngIf="documentForm">
													<table class="table table-striped table-bordered">
														<thead>
															<tr>
																<th>Action</th>
																<th>Upload File</th>
																<th>Remarks</th>
															</tr>
														</thead>
														<tbody formArrayName="documentArray">
															<tr *ngFor="let item of documentForm.controls.documentArray.controls; let $index=index"
																[formGroupName]="$index">
																<td (click)="deleteRow($index)">
																	<i class="fa fa-trash fa-2x"></i>
																</td>
																<td>
																	<div class="form-group">
																		<div class="custom-file">
																			<input type="file"
																				class="form-control custom-file-input"
																				ng2FileSelect [uploader]="uploader"
																				id="file-upload-single" accept=".pdf"
																				(click)="browsbuttonClick('document',$index)"
																				(change)="uploadFileChange($event,'document',$index, 25)"
																				formControlName="uploadDocument"
																				[ngClass]="{ 'is-invalid': documentForm.controls['documentArray'].controls[$index].controls['uploadDocument'].touched && documentForm.controls['documentArray'].controls[$index].controls['uploadDocument'].invalid}" />
																			<label class="custom-file-label"
																				id="uploadDocument"
																				for="file-upload-single"
																				aria-placeholder="Upload file">{{documentForm.controls['documentArray'].controls[$index].controls['documentFileName'].value}}</label>
																		</div>
																		<span
																			*ngIf="documentForm.controls['documentArray'].controls[$index].controls['uploadDocument'].invalid"
																			class="invalid-form">
																			<small class="form-text text-danger"
																				*ngIf="documentForm.controls['documentArray'].controls[$index].controls['uploadDocument'].touched && documentForm.controls['documentArray'].controls[$index].controls['uploadDocument'].hasError('required')">
																				Required!
																			</small>
																		</span>
																	</div>
																</td>
																<td style="min-width: 120px;">
																	<input class="form-control" type="text"
																		formControlName="documentRemark"
																		[ngClass]="{ 'is-invalid': documentForm.controls['documentArray'].controls[$index].controls['documentRemark'].touched 
                                                                  && documentForm.controls['documentArray'].controls[$index].controls['documentRemark'].invalid}" />
																	<span
																		*ngIf="documentForm.controls['documentArray'].controls[$index].controls['documentRemark'].invalid"
																		class="invalid-form">
																		<small class="form-text text-danger"
																			*ngIf="documentForm.controls['documentArray'].controls[$index].controls['documentRemark'].touched && documentForm.controls['documentArray'].controls[$index].controls['documentRemark'].hasError('required')">
																			Required!
																		</small>
																	</span>
																</td>
															</tr>
															<tr>
																<td (click)="addfileRow()">
																	<i class="fa fa-plus fa-2x"></i>
																</td>
															</tr>
														</tbody>
													</table>
												</form>
											</div>
										</div>
									</fieldset>
									<fieldset class="border" style="padding: 0.7rem;">
										<legend class="w-auto">
											<h5 style="margin-top: 7px;">Manpower trained under the project</h5>
										</legend>
										<div class="row">
											<div class="form-group col-md-4">
												<label class="form-label" for="scientistsAndAssociated">Research
													Scientists/ Research Associates <span
														class="required-asterisk">*</span></label>
												<input formControlName="scientistsAndAssociated" type="text"
													name="scientistsAndAssociated" id="scientistsAndAssociated"
													class="form-control"
													placeholder="Research Scientists/ Research Associates"
													[ngClass]="{ 'is-invalid': submitted && !formDetails.scientistsAndAssociated.valid }" />
												<span *ngIf="submitted && formDetails.scientistsAndAssociated.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="formDetails.scientistsAndAssociated.errors.required">This
														field is required!</small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="noOfPhd">No. of Ph.D. (s)
													produced <span class="required-asterisk">*</span></label>
												<input formControlName="noOfPhd" type="text" name="noOfPhd" id="noOfPhd"
													class="form-control" placeholder="No. of Ph.D. (s) produced"
													[ngClass]="{ 'is-invalid': submitted && !formDetails.noOfPhd.valid }" />
												<span *ngIf="submitted && formDetails.noOfPhd.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="formDetails.noOfPhd.errors.required">This
														field is required!</small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="technicalpersonnel">Other Technical
													Personnel trained <span class="required-asterisk">*</span></label>
												<input formControlName="technicalpersonnel" type="text"
													name="technicalpersonnel" id="technicalpersonnel"
													class="form-control" placeholder="Other Technical Personnel trained"
													[ngClass]="{ 'is-invalid': submitted && !formDetails.technicalpersonnel.valid }" />
												<span *ngIf="submitted && formDetails.technicalpersonnel.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="formDetails.technicalpersonnel.errors.required">This
														field is required!</small>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="form-group col-md-4">
												<label class="form-label" for="campsOrganized">Awareness,
													training camps, etc. organized <span
														class="required-asterisk">*</span></label>
												<input formControlName="campsOrganized" type="text"
													name="campsOrganized" id="campsOrganized" class="form-control"
													placeholder="Awareness,training camps, etc. organized"
													[ngClass]="{ 'is-invalid': submitted && !formDetails.campsOrganized.valid }" />
												<span *ngIf="submitted && formDetails.campsOrganized.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="formDetails.campsOrganized.errors.required">This
														field is required!</small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="detailsOfWork">Details of work which
													could not be completed ( if any) <span
														class="required-asterisk">*</span></label>
												<textarea formControlName="detailsOfWork" type="text"
													name="detailsOfWork" id="detailsOfWork" rows="1"
													class="form-control" placeholder="Details of work"
													[ngClass]="{ 'is-invalid': submitted && !formDetails.detailsOfWork.valid }"></textarea>
												<span *ngIf="submitted && formDetails.detailsOfWork.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="formDetails.detailsOfWork.errors.required">This
														field is required!</small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="suggestions">Suggestions on further
													work on the subject of research <span
														class="required-asterisk">*</span></label>
												<textarea formControlName="suggestions" type="text" name="suggestions"
													id="suggestions" class="form-control" rows="1"
													placeholder="Details of work"
													[ngClass]="{ 'is-invalid': submitted && !formDetails.suggestions.valid }"></textarea>
												<span *ngIf="submitted && formDetails.suggestions.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="formDetails.suggestions.errors.required">This
														field is required!</small>
												</span>
											</div>
										</div>
									</fieldset>
									<fieldset class="border" style="padding: 0.7rem;">
										<legend class="w-auto">
											<h5 style="margin-top: 7px;">Project Expenditure</h5>
										</legend>
										<form [formGroup]="projectExpenditureForm" *ngIf="projectExpenditureForm">
											<table class="table table-striped table-bordered">
												<thead>
													<tr>
														<th>No</th>
														<th>Financial Position/ Budget Head</th>
														<th>Amount Sanctioned (Rs.)</th>
														<th>Actual Expenditure (Rs.)</th>
														<th>Deviation if any (Rs.)</th>
														<th>% of Total cost</th>
													</tr>	
												</thead>
												<tbody formArrayName="projectExpenditureArray">
													<tr *ngFor="let item of projectExpenditureForm.controls.projectExpenditureArray.controls;let $index = index" [formGroupName]="$index">
														
														<td>{{ $index + 1 }}</td>
														<td>{{ projectExpenditureForm.controls["projectExpenditureArray"].controls[$index].controls["proposedCostItemName"].value}}</td>
														<td>
															<input class="form-control" type="text" curencyFormat formControlName="amountSanctioned" [ngClass]="{'is-invalid':projectExpenditureForm.controls['projectExpenditureArray']
															.controls[$index].controls['amountSanctioned'].touched && projectExpenditureForm.controls['projectExpenditureArray'].controls[$index].controls['amountSanctioned'].invalid}"
															[mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'" onKeyPress="if(this.value.length==15) return false;"  (change)="onChangeFieldTotal($index)"/>
														</td>
														<td>
															<input class="form-control" type="text" curencyFormat formControlName="actualExpenditure" [ngClass]="{'is-invalid':projectExpenditureForm.controls['projectExpenditureArray']
															.controls[$index].controls['actualExpenditure'].touched && projectExpenditureForm.controls['projectExpenditureArray'].controls[$index].controls['actualExpenditure'].invalid}"
															[mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'" onKeyPress="if(this.value.length==15) return false;"  (change)="onChangeFieldTotal($index)"/>
														</td>
														<td>
															<input class="form-control" type="text" curencyFormat formControlName="deviation" [ngClass]="{'is-invalid':projectExpenditureForm.controls['projectExpenditureArray']
															.controls[$index].controls['deviation'].touched && projectExpenditureForm.controls['projectExpenditureArray'].controls[$index].controls['deviation'].invalid}"
															[mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'" onKeyPress="if(this.value.length==15) return false;"  (change)="onChangeFieldTotal($index)"/>
														</td>
														<td>
															<input class="form-control" type="text" curencyFormat formControlName="expenditureTotalCost" [ngClass]="{'is-invalid':projectExpenditureForm.controls['projectExpenditureArray']
															.controls[$index].controls['expenditureTotalCost'].touched && projectExpenditureForm.controls['projectExpenditureArray'].controls[$index].controls['expenditureTotalCost'].invalid || (isFormInvalid && indexValue == $index)} "
															[mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'" onKeyPress="if(this.value.length==3) return false;"  (change)="onChangeFieldTotal($index)"/>

															<span *ngIf="indexValue == $index && isFormInvalid"
																class="invalid-form">
																<small class="form-text text-danger">
																	<small class="form-text text-danger">Percentage of total cost should not greater than 100 !</small>
																</small>
															</span>
														</td>
													</tr>	
													<tr>
														<td></td>
														<td>
															Total
														</td>
														<td>
															<span>{{formDetails.accountsGrandTotal.value}}</span>
														</td>
														<td>
															<span>{{formDetails.expendituresGrandTotal.value}}</span>
														</td>
														<td>
															<span>{{formDetails.deviationsGrandTotal.value}}</span>
														</td>
														<td>
															<span>{{formDetails.totalCostGrandTotal.value}}</span>
														</td>
													</tr>
												</tbody>
											</table>
										</form>
									</fieldset>
									<fieldset class="border" style="padding: 0.7rem;">
										<legend class="w-auto">
											<h5 style="margin-top: 7px;">Equipment Status</h5>
										</legend>
										<div class="form-group">
											<form [formGroup]="equipmentStatusForm" *ngIf="equipmentStatusForm">
												<table class="table table-striped table-bordered">
													<thead>
														<tr>
															<th>Action</th>
															<th>Name of Equipment</th>
															<th>Year of Purchase</th>
															<th>Make/ Model</th>
															<th>Cost (Rs.)</th>
															<th>Date of Installation</th>
															<th>Utilization Rate (%)</th>
															<th>Remarks regarding Maintenance/Breakdown</th>
														</tr>
													</thead>
													<tbody formArrayName="EquipmentStatusArray">
														<tr *ngFor="let items of equipmentStatusForm.controls.EquipmentStatusArray.controls; let $indexes=index"
															[formGroupName]="$indexes">
															<td (click)="deleteEquipmentFormRow($indexes)">
																<i class="fa fa-trash fa-2x"></i>
															</td>
															<td>
																<input class="form-control" type="text"
																	formControlName="nameOfEquipment"
																	[ngClass]="{ 'is-invalid': equipmentStatusForm.controls['EquipmentStatusArray'].
                                                                    controls[$indexes].controls['nameOfEquipment'].
                                                                    touched && equipmentStatusForm.controls['EquipmentStatusArray'].
                                                                    controls[$indexes].controls['nameOfEquipment'].invalid}" />
																<span
																	*ngIf="equipmentStatusForm.controls['EquipmentStatusArray'].
                                                                    controls[$indexes].controls['nameOfEquipment'].invalid"
																	class="invalid-form">
																	<small class="form-text text-danger"
																		*ngIf="equipmentStatusForm.controls['EquipmentStatusArray'].
                                                                        controls[$indexes].controls['nameOfEquipment'].touched && 
                                                                        equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['nameOfEquipment'].hasError('required')">
																		Required!
																	</small>
																</span>
															</td>
															<td>
																<input class="form-control" type="text"
																	formControlName="yearOfPurchase"
																	[mask]="'^([1-9]\\d*|0)$'"
																	onKeyPress="if(this.value.length==4) return false;"
																	[ngClass]="{ 'is-invalid': equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['yearOfPurchase'].touched && equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['yearOfPurchase'].invalid}" />
																<span
																	*ngIf="equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['yearOfPurchase'].invalid"
																	class="invalid-form">
																	<small class="form-text text-danger"
																		*ngIf="equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['yearOfPurchase'].touched && equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['yearOfPurchase'].hasError('required')">
																		Required!
																	</small>
																</span>
															</td>
															<td>
																<input class="form-control" type="text"
																	formControlName="makeModel"
																	[ngClass]="{ 'is-invalid': equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['makeModel'].touched && equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['makeModel'].invalid}" />
																<span
																	*ngIf="equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['makeModel'].invalid"
																	class="invalid-form">
																	<small class="form-text text-danger"
																		*ngIf="equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['makeModel'].touched && equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['makeModel'].hasError('required')">
																		Required!
																	</small>
																</span>
															</td>
															<td>
																<input class="form-control" type="text" curencyFormat
																	formControlName="costOfInstallation"
																	onKeyPress="if(this.value.length==15) return false;"
																	[mask]="'^([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'"
																	[ngClass]="{ 'is-invalid': equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['costOfInstallation'].touched && equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['costOfInstallation'].invalid}" />
																<span
																	*ngIf="equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['costOfInstallation'].invalid"
																	class="invalid-form">
																	<small class="form-text text-danger"
																		*ngIf="equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['costOfInstallation'].touched && equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['costOfInstallation'].hasError('required')">
																		Required!
																	</small>
																</span>
															</td>
															<td>
																<div class="input-group">
																	<input class="form-control" placeholder="dd-mm-yyyy"
																		name="dateOfInstallation"
																		formControlName="dateOfInstallation"
																		ngbDatepicker #MinMaxDP="ngbDatepicker"
																		[minDate]="{year: minDate.year, month: minDate.month, day:minDate.day}"
																		[ngClass]="{ 'is-invalid': equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['dateOfInstallation'].touched && equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['dateOfInstallation'].invalid}"
																		[readonly]="true" />
																	<div class="input-group-append">
																		<button
																			class="btn btn-outline-secondary feather icon-calendar"
																			(click)="MinMaxDP.toggle();" type="button"
																			rippleEffect></button>
																	</div>
																</div>
																<span
																	*ngIf="equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['dateOfInstallation'].invalid"
																	class="invalid-form">
																	<small class="form-text text-danger"
																		*ngIf="equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['dateOfInstallation'].touched && equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['dateOfInstallation'].hasError('required')">
																		Required!
																	</small>
																</span>
															</td>
															<td>
																<input class="form-control" type="text"
																	formControlName="rate"
																	[mask]="'^([1-9]\\d*|0)$'"
																	onKeyPress="if(this.value.length==3) return false;"
																	[ngClass]="{ 'is-invalid': equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['rate'].touched && equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['rate'].invalid}"
																	 />
																<span
																	*ngIf="equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['rate'].invalid"
																	class="invalid-form">
																	<small class="form-text text-danger"
																		*ngIf="equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['rate'].touched && equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['rate'].hasError('required')">
																		Required!
																	</small>
																</span>
															</td>
															<td>
																<textarea class="form-control" type="text"
																	formControlName="remarks"
																	[ngClass]="{ 'is-invalid': equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['remarks'].touched && equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['remarks'].invalid}">
                                                                </textarea>
																<span
																	*ngIf="equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['remarks'].invalid"
																	class="invalid-form">
																	<small class="form-text text-danger"
																		*ngIf="equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['remarks'].touched && equipmentStatusForm.controls['EquipmentStatusArray'].controls[$indexes].controls['remarks'].hasError('required')">
																		Required!
																	</small>
																</span>
															</td>
														</tr>
														<tr>
															<td (click)="addEquimentRow()">
																<i class="fa fa-plus fa-2x"></i>
															</td>
														</tr>
													</tbody>
												</table>
											</form>
										</div>
									</fieldset>
									<fieldset class="border" style="padding: 0.7rem;">
										<legend class="w-auto">
											<h5 style="margin-top: 7px;">Manpower</h5>
										</legend>
										<table class="table table-striped table-bordered">
											<thead>
												<tr>
													<th>Sanctioned List</th>
													<th>In position at the time of project completion (Yes/ No)</th>
													<th>Pay Scalec/ Emoluments</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let item of manPowerDetails; let $index=index">
													<td class="text-wrap text-justify">{{item.sanctionList ? item.sanctionList : "Record Not Found"}}
													</td>
													<td>{{item.inPosition ? item.inPosition : "Record Not Found"}}</td>
													<td class="text-wrap text-justify">{{item.scale ? item.scale : "Record Not Found"}}</td>
												</tr>
											</tbody>
										</table>
									</fieldset>
									<div class="d-flex justify-content-between submitbtn">
										<button class="btn btn-success btn-submit" (click)="saveCompletionReportData()"
											rippleEffect>Submit</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</div>